module.exports = __webpack_public_path__ + "static/media/Group 24934.80b22380.svg";